/**
 * Texto de cada passo do tour de onboarding, indexado pelo `path` de
 * STATIC_NAV (Sidebar.tsx) — é essa chave que o useTourSteps usa pra
 * cruzar "o que existe no menu para este usuário" com "o que ensinar".
 * Paths do STATIC_NAV sem entrada aqui são pulados pelo tour.
 */
export interface TourStepContent {
  title: string;
  rule: string;
}

export const TOUR_STEP_CONTENT: Record<string, TourStepContent> = {
  '/visao-geral': {
    title: 'Visão geral',
    rule: 'Resumo do dia: chegadas, saídas, ocupação e faturamento. É o primeiro lugar a olhar de manhã.',
  },
  '/ocupacao': {
    title: 'Mapa de Ocupação',
    rule: 'Cada linha é um quarto, cada bloco é uma reserva — arraste para trocar o quarto. Quarto com risco vermelho está em manutenção e fica travado até você liberar.',
  },
  '/reservas': {
    title: 'Reservas',
    rule: 'O status segue o fluxo: Confirmada → Check-in → Check-out. O check-in só libera na data de chegada, com a reserva confirmada e o quarto fora de manutenção.',
  },
  '/hospedes': {
    title: 'Hóspedes',
    rule: 'Cada hóspede tem um cadastro central. Se ele voltar em outra reserva, o sistema reconhece — não precisa recadastrar.',
  },
  '/portais-dos-hospedes': {
    title: 'Portal dos hóspedes',
    rule: 'Toda reserva gera um link de pré-check-in e um portal para o hóspede acompanhar a estadia. Ele preenche os dados antes de chegar, o que agiliza a entrada.',
  },
  '/governanca': {
    title: 'Governança',
    rule: "Quando o hóspede faz check-out, o quarto vira 'Sujo' automaticamente — é o aviso para a limpeza. Quarto em manutenção fica travado no mapa até você concluir o reparo.",
  },
  '/financeiro': {
    title: 'Financeiro',
    rule: 'Aqui é a tesouraria do próprio hotel: fornecedores, agências e empresas — não é a conta do hóspede. Diárias e consumos de hospedagem ficam na conta da reserva (aba "Conta e pagamentos"), não aparecem aqui.',
  },
  '/auditoria-noturna': {
    title: 'Auditoria noturna',
    rule: 'Roda o fechamento do dia e lança as diárias pendentes. Se ainda faltar diária não faturada até a data de saída, o check-out fica bloqueado até você rodar essa auditoria.',
  },
  '/gerenciador-de-canais': {
    title: 'Channel Manager',
    rule: 'Depois de conectar um canal (Booking, Airbnb...), a disponibilidade sincroniza sozinha a cada reserva ou bloqueio de manutenção. Tarifa nova só chega aos canais no "Sincronizar" manual em Tarifas ou na rotina automática de madrugada — não no instante em que você salva.',
  },
  '/tarifas': {
    title: 'Tarifas',
    rule: 'Defina o preço base por tipo de quarto. Editar aqui não avisa os canais na hora — o valor novo chega no "Sincronizar" manual ou na rotina automática de madrugada.',
  },
  '/manutencoes': {
    title: 'Manutenções',
    rule: 'Reportar um problema aqui bloqueia o quarto no mapa de ocupação até alguém marcar como concluído — ninguém aloca hóspede num quarto quebrado.',
  },
  '/estoque-e-consumo': {
    title: 'Estoque e consumo',
    rule: 'Controle de itens e insumos do hotel — quantidade, custo e fornecedor. Registre a movimentação aqui para entrada/saída manual; um consumo vinculado a um item de estoque e lançado direto na conta da reserva já debita o estoque sozinho, então não lance de novo.',
  },
  '/relatorios': {
    title: 'Relatórios',
    rule: 'Ocupação, RevPAR e origem de reservas aqui vêm das reservas e diárias já lançadas no sistema — não são estimativas.',
  },
  '/mensagens': {
    title: 'Mensagens da equipe',
    rule: 'Chat interno por setor (recepção, governança...), separado da conversa com o hóspede.',
  },
};
